const OBJECT = 'object';
const UNDEFINED = 'undefined';
const isFunction = (obj) => typeof obj === 'function';
function deepExtendOne(destination, source) {
    for (const property in source) {
        if (property === '__proto__' || property === 'constructor') {
            continue;
        }
        const propValue = source[property];
        const propType = typeof propValue;
        let propInit;
        if (propType === OBJECT && propValue !== null) {
            propInit = propValue.constructor;
        }
        else {
            propInit = null;
        }
        if (propInit && propInit !== Array) {
            if (propValue instanceof Date) {
                destination[property] = new Date(propValue.getTime());
            }
            else if (isFunction(propValue.clone)) {
                destination[property] = propValue.clone();
            }
            else {
                const destProp = destination[property];
                if (typeof (destProp) === OBJECT) {
                    destination[property] = destProp || {};
                }
                else {
                    destination[property] = {};
                }
                deepExtendOne(destination[property], propValue);
            }
        }
        else if (propType !== UNDEFINED) {
            destination[property] = propValue;
        }
    }
    return destination;
}
function deepExtend(destination, ...sources) {
    const length = sources.length;
    for (let i = 0; i < length; i++) {
        deepExtendOne(destination, sources[i]);
    }
    return destination;
}
export { deepExtend };
